import React, { createContext, useContext, useEffect, useState } from 'react';
import { es, Translation } from '../data/translations.es';
import { en } from '../data/translations.en';
export type Lang = 'es' | 'en';
const dictionaries: Record<Lang, Translation> = {
  es,
  en
};
type LanguageContextValue = {
  lang: Lang;
  setLang: (lang: Lang) => void;
  toggleLang: () => void;
  t: Translation;
};
const LanguageContext = createContext<LanguageContextValue | null>(null);
const STORAGE_KEY = 'ase-lang';
function getInitialLang(): Lang {
  if (typeof window === 'undefined') return 'es';
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored === 'es' || stored === 'en') return stored;
  return window.navigator.language?.toLowerCase().startsWith('en') ? 'en' : 'es';
}
type Props = {
  children: React.ReactNode;
};
export function LanguageProvider({
  children
}: Props) {
  const [lang, setLang] = useState<Lang>(getInitialLang);
  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const toggleLang = () => setLang(current => current === 'es' ? 'en' : 'es');
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    toggleLang,
    t: dictionaries[lang]
  }} data-id="element-479" data-mp="3cyitmgswtpk5">
      {children}
    </LanguageContext.Provider>;
}
export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error('useLang must be used within a LanguageProvider');
  }
  return ctx;
}